import script from "./desktop.vue?vue&type=script&setup=true&lang=js"
export * from "./desktop.vue?vue&type=script&setup=true&lang=js"

import "./desktop.vue?vue&type=style&index=0&id=42a01830&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a01830"]])

export default __exports__